module EEX.McEc.Commands {

    export class SavePrivateKeyToFileCommand {

        public savePrivateKey(store: Pki.Store, privateKeyPassword: string, privateKeyFileName : string, success: (store: Pki.Store) => void) {
            store.getPrivateKeyPem(privateKeyPassword);
            var dataUri = "data:application/x-pem-file;base64," + Pki.Store.toBase64(store.getPkPem());
            kendo.saveAs({
                dataURI: dataUri,
                fileName: privateKeyFileName
            });
            success(store);
        }
    }
}
